// extracted by mini-css-extract-plugin
export default {"wrapper":"I5-z","play":"J5-z"};